import React, { useState } from 'react'
import SvgIcon from 'components/SvgIcon/SvgIcon'
import MyLink from 'components/MyLink'

// Mobile menu item component for the modal
const MobileMenuItem = ({ item, level = 0, onClose }) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = item?.children && item?.children?.length > 0;
  
  const toggleOpen = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    setIsOpen(!isOpen);
  };
  
  return (
    <li className={`mobile-menu-item ${hasChildren ? 'has-children' : ''} level-${level}`}>
      <div className="mobile-menu-item-header">
        <MyLink
          to={item?.url}
          className="mobile-menu-link"
          onClick={hasChildren ? null : onClose}
        >
          {item?.text}
        </MyLink>
        {hasChildren && (
          <button
            className={`mobile-dropdown-toggle ${isOpen ? 'open' : ''}`}
            onClick={toggleOpen}
          >
            <SvgIcon name='wparrow' className='mobile-arrow' />
          </button>
        )}
      </div>
      
      {hasChildren && isOpen && (
        <ul className="mobile-submenu">
          {item?.children?.map?.(child => (
            <MobileMenuItem
              key={child?.id}
              item={child}
              level={level + 1}
              onClose={onClose}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default MobileMenuItem;